module.exports = __webpack_public_path__ + "media/img/pages/profile/lgt ger 3-9b44cddd475e16b5761f3d04fd6eacdf.jpg";